/**
 * FairwayBid – Angebotsfristen
 *
 * Eine Anfrage traegt im Feld quote_deadline nur eine relative Angabe
 * ("21 Tage nach Veroeffentlichung"). Das tatsaechliche Fristende ergibt sich
 * erst aus dem Veroeffentlichungsdatum. Dieses Modul rechnet das aus und
 * liefert fertige deutsche Texte, damit Clubs auf einen Blick sehen, wie viel
 * Zeit den Haendlern noch bleibt.
 */

export const QUOTE_DEADLINE_DAYS = {
  qd_7: 7,
  qd_14: 14,
  qd_21: 21,
  qd_30: 30,
};

// Ab hier gilt die Frist als knapp und wird hervorgehoben.
export const URGENT_DAYS = 7;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const toDate = value => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const formatDate = value => {
  const d = toDate(value);
  return d
    ? d.toLocaleDateString('de-DE', { day: 'numeric', month: 'long', year: 'numeric' })
    : null;
};

/**
 * Ende der Angebotsfrist als Date, oder null wenn die Anfrage keine Frist
 * traegt oder noch nicht veroeffentlicht ist.
 */
export const getDeadline = listing => {
  const attrs = listing?.attributes;
  const days = QUOTE_DEADLINE_DAYS[(attrs?.publicData?.quote_deadline)];
  const start = toDate(attrs?.publishedAt || attrs?.createdAt);
  if (!days || !start) return null;
  const end = new Date(start.getTime());
  end.setDate(end.getDate() + days);
  return end;
};

/**
 * Status der Angebotsfrist einer Anfrage.
 *
 * @returns {{end: Date, daysLeft: number, expired: boolean, urgent: boolean,
 *            label: string, dateLabel: string}|null}
 */
export const getDeadlineStatus = (listing, now = new Date()) => {
  const end = getDeadline(listing);
  if (!end) return null;

  const daysLeft = Math.ceil((end.getTime() - now.getTime()) / MS_PER_DAY);
  const expired = daysLeft <= 0;
  const urgent = !expired && daysLeft <= URGENT_DAYS;

  const label = expired
    ? 'Angebotsfrist abgelaufen'
    : daysLeft === 1
    ? 'Noch 1 Tag für Angebote'
    : `Noch ${daysLeft} Tage für Angebote`;

  /*
    Die kurze Form fuer enge Stellen - in einer Chip-Zeile auf dem Telefon
    ist "fuer Angebote" der Teil, der die Zeile umbrechen laesst, und der
    Teil, den ohnehin jeder kennt. Der volle Satz bleibt als label erhalten.
  */
  const kurzLabel = expired
    ? 'Frist abgelaufen'
    : daysLeft === 1
    ? 'Noch 1 Tag'
    : `Noch ${daysLeft} Tage`;

  return { end, daysLeft, expired, urgent, label, kurzLabel, dateLabel: formatDate(end) };
};
